import { css } from 'styled-components';

export const parseStyleDict = (
  styleDict: any,
  elementTagName: keyof HTMLElementTagNameMap = 'body',
) => {
  const element = document.createElement(elementTagName);

  const pStyleDict: any = {};
  Object.keys(styleDict).forEach((key) => {
    // Removes any key that cannot be used for styles for given element.
    // Like `children`, `variation` and similar.
    if (!(key in element.style)) return;

    let pKey = '';

    for (let i = 0; i < key.length; i++) {
      if (key[i] === key[i].toLowerCase()) pKey += key[i];
      else pKey += `-${key[i].toLowerCase()}`;
    }

    pStyleDict[pKey] = styleDict[key];
  });

  return pStyleDict;
};

export const extractCssStyle = (
  styleDict: any,
  elementTagName: keyof HTMLElementTagNameMap = 'body',
) => {
  const pStyleDict = parseStyleDict(styleDict, elementTagName);

  return css`
    ${Object.keys(pStyleDict)
      .map((key) => {
        return `${key}:${pStyleDict[key]}`;
      })
      .join(';')}
  `;
};

export const pxToEm = (px: number) => px / 16;
